import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import posthog from "posthog-js";
import PostHogPageviewTracker from "./PostHogPageviewTracker";
import { PostHogProvider } from "posthog-js/react";

posthog.init("phc_k9r7uHjKoW2JjwkPj3eCg26Qp6qib5xJDaZNmXEyUsQ", {
  api_host: "https://us.i.posthog.com",
  capture_pageview: false,
  capture_pageleave: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <PostHogProvider client={posthog}>
    <BrowserRouter>
      <PostHogPageviewTracker />
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </PostHogProvider>
);
